// extracted by mini-css-extract-plugin
export default {"tab__wrapper":"navPills_tab__wrapper__iFzCu","tab__content":"navPills_tab__content__qKdNT"};